import React from 'react';

/**
 * Inline 7-day SVG sparkline for the PulseStrip cards. Shows a tiny
 * line + the most-recent value highlighted, so admins can see whether
 * a metric is rising or falling without scrolling to the full
 * GrowthChart below.
 */
export const MiniSparkline = ({ values = [], color = '#703FF6', height = 24, width = 110, ariaLabel }) => {
  if (!Array.isArray(values) || values.length < 2) {
    return (
      <svg width={width} height={height} aria-hidden="true" focusable="false">
        <line x1="0" y1={height / 2} x2={width} y2={height / 2} stroke="#E5E7EB" strokeWidth="1" />
      </svg>
    );
  }

  const nums = values.map((v) => Number(v) || 0);
  const max = Math.max(...nums);
  const min = Math.min(...nums);
  const range = Math.max(0.0001, max - min);
  const step = width / (nums.length - 1);
  const points = nums.map((value, idx) => {
    const x = idx * step;
    const y = height - ((value - min) / range) * (height - 4) - 2;
    return [x, y];
  });

  const path = points
    .map(([x, y], idx) => (idx === 0 ? `M ${x.toFixed(1)} ${y.toFixed(1)}` : `L ${x.toFixed(1)} ${y.toFixed(1)}`))
    .join(' ');
  const areaPath = `${path} L ${width} ${height} L 0 ${height} Z`;

  const [lastX, lastY] = points[points.length - 1];

  return (
    <svg width={width} height={height} role="img" aria-label={ariaLabel || 'Sparkline'} style={{ display: 'block', overflow: 'visible' }}>
      <defs>
        <linearGradient id={`spark-grad-${color.replace('#', '')}`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0.25" />
          <stop offset="100%" stopColor={color} stopOpacity="0" />
        </linearGradient>
      </defs>
      <path d={areaPath} fill={`url(#spark-grad-${color.replace('#', '')})`} />
      <path d={path} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx={lastX} cy={lastY} r="2.5" fill={color} stroke="#FFFFFF" strokeWidth="1" />
    </svg>
  );
};

export default MiniSparkline;
